export default __webpack_public_path__ + "static/media/MORE.f2460cf9.png";